import * as $ from 'jquery';
import {Context} from "./Context";

let ctx = new Context();

let clicked: boolean = false;
let clickID: string;
let submenuOpen = false;
let test = 's';
let selector = '[mobile-nav]';

jQuery(($)=>{
  $('[nav-mobile-menu-toggle]').on('click', (e)=>{
   $('body').toggleClass('body--nav-open');
   $('.nav').toggleClass('nav--open');
  });

  // $('.menu-item-has-children').on('click', (e)=>{
  //  $('.menu-item-has-children').removeClass('.menu-item-open');
  //  $(e.currentTarget).addClass('.menu-item-open');
  // })

  let element = $(selector);
  let mobileMenuItemSelector = '.mobile-nav-new__item';

  $('[mobile-sub-menu-trigger]', element).on('click', (e)=>{
      let li = $(e.currentTarget).parent();
   if(!li.hasClass('mobile-nav-new__item--open'))
   {
    e.preventDefault();
    e.stopPropagation();
   }

   li.addClass('mobile-nav-new__item--open');
  });

  $('[mobile-sub-menu-close-trigger]', element).on('click', (e)=>{
      e.stopPropagation();
      e.preventDefault();

      let li = $(e.currentTarget).parent().parent()
      ;

      if(li.hasClass('mobile-nav-new__item--open'))
      {
          li.removeClass('mobile-nav-new__item--open');
      }else{
          li.addClass('mobile-nav-new__item--open');
      }

  });
});


